/** @jsxImportSource @emotion/react */
import { useLocation } from "react-router-dom";
import BookingList from "./booking-list";
import MyBooking from "./my-booking";
import NoshowPolicyManagement from "./NoshowPolicyManagement/NoshowPolicyManagementPage";
import SettingAlarm from "./setting-alarm";
import SettingTabletAlarm from "./setting-tablet-policy";
import ComplainList from "./complain-list";
import ComplaintCategories from "./complain-categories";
import ComplainManagerSetting from "./complain-manager-setting";
import ProtectedRoute from "ProtectedRoute";
import { allRoles, policyAdminRoles, superAdminRoles } from "utils/role";
import RedirectRoute from "RedirectRoute";
import Root from "pages/root";
import { useRecoilValue } from "recoil";
import { complainManager } from "recoil/recoilState";
import MyAlarmManage from "./my-alarm-manage";
import {
  MinimumAttendeesManagementPage,
  MeetingRoomManagementPage,
  MeetingRoomDeviceManagementPage,
} from "./MeetingRoomManage";
import MeetingRoomRestrictionRequestPage from "./MeetingRoomRestrictionRequest/MeetingRoomRestrictionRequestPage";
import MeetingRoomRestrictionManagePage from "./MeetingRoomRestrictionManage/MeetingRoomRestrictionManagePage";

export default function MeetingNavigation() {
  const location = useLocation().pathname;
  const paths = decodeURIComponent(location);
  const complainManagerState = useRecoilValue(complainManager);

  const getPage = () => {
    if (paths.includes("예약 현황")) {
      return <BookingList />;
    }
    if (paths.includes("나의 예약")) {
      return <MyBooking />;
    }
    if (paths.includes("나의 알림 설정")) {
      return <MyAlarmManage />;
    }
    if (paths.includes("회의실 예약 제한 요청")) {
      return <MeetingRoomRestrictionRequestPage />;
    }
    if (paths.includes("운영/예약 정책 관리")) {
      if (paths.includes("노쇼 정책 관리")) {
        return <ProtectedRoute element={<NoshowPolicyManagement />} page={paths} accessRoles={policyAdminRoles} />;
      }
      if (paths.includes("알림 정책 설정")) {
        return <ProtectedRoute element={<SettingAlarm />} page={paths} accessRoles={policyAdminRoles} />;
      }
      if (paths.includes("태블릿 정책 설정")) {
        return <ProtectedRoute element={<SettingTabletAlarm />} page={paths} accessRoles={policyAdminRoles} />;
      }
      if (paths.includes("최소 참석 인원 관리")) {
        return (
          <ProtectedRoute element={<MinimumAttendeesManagementPage />} page={paths} accessRoles={policyAdminRoles} />
        );
      }
      if (paths.includes("예약 제한 요청 관리")) {
        return (
          <ProtectedRoute element={<MeetingRoomRestrictionManagePage />} page={paths} accessRoles={superAdminRoles} />
        );
      }
      return (
        <RedirectRoute
          page={`/meeting/${encodeURIComponent("운영/예약 정책 관리")}/${encodeURIComponent("노쇼 정책 관리")}`}
        />
      );
    }
    if (paths.includes("회의실 관리")) {
      if (paths.includes("회의실 등록 및 설정")) {
        return <ProtectedRoute element={<MeetingRoomManagementPage />} page={paths} accessRoles={policyAdminRoles} />;
      }
      if (paths.includes("회의실 기기 관리")) {
        return (
          <ProtectedRoute element={<MeetingRoomDeviceManagementPage />} page={paths} accessRoles={policyAdminRoles} />
        );
      }
      return (
        <RedirectRoute
          page={`/meeting/${encodeURIComponent("회의실 관리")}/${encodeURIComponent("회의실 등록 및 설정")}`}
        />
      );
    }

    if (paths.includes("회의실 민원 관리")) {
      if (paths.includes("민원 내역 조회")) {
        return (
          <ProtectedRoute
            element={<ComplainList />}
            page={paths}
            accessRoles={complainManagerState ? allRoles : policyAdminRoles}
          />
        );
      }
      if (paths.includes("민원 유형 설정")) {
        return <ProtectedRoute element={<ComplaintCategories />} page={paths} accessRoles={policyAdminRoles} />;
      }
      if (paths.includes("민원 담당자 설정")) {
        return <ProtectedRoute element={<ComplainManagerSetting />} page={paths} accessRoles={policyAdminRoles} />;
      }
      return (
        <RedirectRoute
          page={`/meeting/${encodeURIComponent("회의실 민원 관리")}/${encodeURIComponent("민원 내역 조회")}`}
        />
      );
    }

    return <RedirectRoute page={`/meeting/${encodeURIComponent("예약 현황")}`} />;
  };

  return (
    <>
      <Root>{getPage() ?? <></>}</Root>
    </>
  );
}
